import React from "react";

const ADZUNA_LOGO_URL = "https://zunastatic-abf.kxcdn.com/images/global/landing/press/logo_normal.png";
const ADZUNA_URL = "https://www.adzuna.es";

/* Atribucion MINIMA exigida por los Terminos de Adzuna (developer.adzuna.com/docs/terms_of_service):
   "Jobs by Adzuna" en cada aviso mostrado, min 116x23px, "Jobs" hyperlinked +
   logo real de Adzuna hyperlinked. Nada mas — sin banners, sin colores de marca,
   sin repetirlo fuera de lo obligatorio (por eso NO hay aviso a nivel de listado). */
export function AdzunaAttribution({ testId, size = "default", onDark = false }) {
  const compact = size === "compact";
  return (
    <a
      href={ADZUNA_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      data-testid={testId}
      title="Jobs by Adzuna"
      style={{
        display: "inline-flex", alignItems: "center", gap: "4px",
        minWidth: "116px", height: "23px", padding: "0 6px",
        fontSize: compact ? "9.5px" : "10.5px", fontFamily: "Poppins, sans-serif",
        color: onDark ? "rgba(255,255,255,0.85)" : "#94A3B8", textDecoration: "none", flexShrink: 0, whiteSpace: "nowrap",
      }}
    >
      Jobs by <img src={ADZUNA_LOGO_URL} alt="Adzuna" style={{ height: "13px", width: "auto", filter: onDark ? "brightness(0) invert(1)" : "none" }} />
    </a>
  );
}
